//NOTE - firstname, hotel, startDate, endDate, countLead,adults,kids,ages,priceName,room,priceCount
export default function () {
    const html =
        `
                    </body>
                    </html>
        `;
    return html;
}